// slots.js

/**
 * Returns all possible slots for a day as { id, label, start, end } objects.
 * Slots run from 08:00 to 24:00 in 30-min increments.
 * Defined once at module level - never recalculated on every render.
 */
export const ALL_SLOTS = (() => {
  const slots = [];
  for (let h = 8; h < 24; h++) {
    for (let m = 0; m < 60; m += 30) {
      const startH  = String(h).padStart(2, "0");
      const startM  = String(m).padStart(2, "0");
      const endM30  = m + 30;
      const endH    = endM30 === 60 ? h + 1 : h;
      const endMin  = endM30 === 60 ? 0 : endM30;
      const endHStr = String(endH).padStart(2, "0");
      const endMStr = String(endMin).padStart(2, "0");
      slots.push({
        id:    `${startH}:${startM}`,
        label: `${startH}:${startM} – ${endHStr}:${endMStr}`,
        start: `${startH}:${startM}`,
        end:   `${endHStr}:${endMStr}`,
      });
    }
  }
  return slots;
})();

/**
 * Turns a list of slot ids (each a 30-min slot, e.g. "17:30", "18:00") into
 * full time ranges, merging back-to-back slots.
 *   ["17:30","18:00"]          -> "17:30 - 18:30"
 *   ["17:30","18:00","20:00"]  -> "17:30 - 18:30, 20:00 - 20:30"
 * `joiner` sets what goes between separate ranges (emails use "\n").
 */
const SLOT_INDEX_BY_ID = new Map(ALL_SLOTS.map((s, i) => [s.id, i]));

export function formatSlotRanges(slotIds, separator = " - ", joiner = ", ") {
  if (!Array.isArray(slotIds) || slotIds.length === 0) return "-";
  const byId = SLOT_INDEX_BY_ID;
  const known = [...new Set(slotIds)]
    .filter((id) => byId.has(id))
    .sort((a, b) => byId.get(a) - byId.get(b));
  const unknown = slotIds.filter((id) => !byId.has(id));
  if (known.length === 0) return unknown.join(joiner) || "-";

  const ranges = [];
  let startIdx = byId.get(known[0]);
  let prevIdx = startIdx;
  for (let i = 1; i <= known.length; i++) {
    const idx = i < known.length ? byId.get(known[i]) : null;
    if (idx !== prevIdx + 1) {
      ranges.push(`${ALL_SLOTS[startIdx].start}${separator}${ALL_SLOTS[prevIdx].end}`);
      startIdx = idx;
    }
    prevIdx = idx;
  }
  return [...ranges, ...unknown].join(joiner);
}
